"use strict";

var ubian = ubian || {};

ubian.appDownload = {};

ubian.appDownload.init = function () {
  if (__ubian_branding != "UBIAN") {
    return;
  }
  var platform = ubian.appDownload.getDevicePlatform();
  if (!platform) {
    return;
  }
  var bannerHidden = Cookies.get("ubian-app-banner");
  if (bannerHidden) {
    return;
  }
  var banner =
    '<div class="app-download-banner"><button class="close js-close-app-download-banner">×</button><span class="app-icon"></span><span class="desc"><span class="app-name">' +
    ubian.translate("JS.AppDownload.App") +
    '</span><span class="app-type">' +
    ubian.translate("JS.AppDownload.Type") +
    '</span><span class="app-price">' +
    ubian.translate("JS.AppDownload.Price", {
      "-platform-": platform == "ios" ? "AppStore" : "Google Play",
    }) +
    '</span></span><a href="--download-url--">' +
    ubian.translate("Button.View") +
    "</a></div>";
  if (platform === "ios") {
    banner = banner.replace(
      "--download-url--",
      "https://itunes.apple.com/sk/app/ubian/id1216229926?l=sk&mt=8#?platform=iphone"
    );
  } else {
    banner = banner.replace(
      "--download-url--",
      "https://play.google.com/store/apps/details?id=eu.ubian&hl=sk"
    );
  }
  $("body").append(banner);
  $("body").addClass("appbanner");
  $("body .js-close-app-download-banner").click(function () {
    ubian.appDownload.hideBanner();
  });
  ubian.appDownload.setShownCookie();
};

ubian.appDownload.hideBanner = function () {
  $("body").removeClass("appbanner");
  $(".app-download-banner").remove();
};
ubian.appDownload.setShownCookie = function () {
  Cookies.set("ubian-app-banner", 1, { expires: 30 });
};

ubian.appDownload.getDevicePlatform = function () {
  if ($("body").hasClass("appmode")) {
    return false;
  }
  var agent = navigator.userAgent;
  if (agent.indexOf("Android") > -1) {
    return "android";
  }
  if (agent.indexOf("iPhone") > -1 || agent.indexOf("iPad") > -1) {
    return "ios";
  }
  return false;
};
